/**
 * @module views\sys\db\templates\basicProperty
 */
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import BaseEditor from "../base";

@Component
export default class BasicProperty extends BaseEditor {
  private keys = [
    "value",
    "text",
    "type",
    "Seq",
    "width",
    "align",
    "hide",
    "edit",
    "isQuery",
    "color",
    "rules"
  ];

  private basicProps: any[] = [];

  @Watch("model")
  private updateBasicProps() {
    this.basicProps = this.getProps(this.keys);
  }
}
